import React from 'react';
import {capitalize} from "../../utils/helpers";

const Tooltip = ({ district, municipality, wardNumber, totalPlanned, totalOngoing, totalCompleted, poCount }) => (
    <div className="panel panel-default">
        <div className="panel-heading">
            <h4 className="panel-title">{capitalize(district)}</h4>
        </div>
        <div className="panel-body">
            <p>Municipality: {municipality}</p>
            <p>Ward number: {wardNumber}</p>
            <p>No. of PO Present.: {poCount}</p>
            <p>
                <span style={{backgroundColor:'#82ca00', ...style}}></span>&nbsp;
                Planned activities: {totalPlanned}
            </p>
            <p>
                <span style={{backgroundColor:'#82ca9d', ...style}}></span>&nbsp;
                Ongoing activities: {totalOngoing}
            </p>
            <p>
                <span style={{backgroundColor:'#8884d8', ...style}}></span>&nbsp;
                Completed activities: {totalCompleted}
            </p>
        </div>
    </div>
);

const style = {
    height:"10px",
    width:"10px",
    display:"inline-block"
}

export default Tooltip;